import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import { useAuthStore } from '../store/Authenticator.ts';
import { useDark } from '@vueuse/core'
import i18n from "../i18n.ts"
import { resolveIsDark, resolveLocale } from '../utils/preferences.ts';

const isDark = useDark();




const routes: Array<RouteRecordRaw> = [
  {
    name: "Main",
    path: "/",
    component: () => import('../views/layout/Main.vue'),
    redirect: '/',
    children: [
      {
        name: 'Home',
        path: '/',
        component: Home,
      },
      {
        name: 'About',
        path: '/about',
        component: About,
      },
      {
        name: 'Pricing',
        path: '/pricing',
        component: () => import('../views/Pricing.vue'),
      },
      {
        name: 'Sign-In',
        path: '/signin',
        component: () => import('../views/Sign-In.vue'),
      },
      {
        name: 'Contact',
        path: '/contact',
        component: () => import('../views/Contact.vue'),
      },
      {
        name: 'Services',
        path: '/services',
        component: () => import('../views/Services.vue'),
      },
      {
        name: 'Sign-Up',
        path: '/signup',
        component: () => import('../views/Sign-Up.vue'),
      },
      {
        name: 'Register',
        path: '/register',
        component: () => import('../views/Register.vue'),
      },
      {
        name: 'RecoverAccount',
        path: '/recoveraccount',
        component: () => import('../views/RecoverAccount.vue'),
      },
      {
        name: 'TermsConditions',
        path: '/termsconditions',
        component: () => import('../views/TermsConditions.vue'),
      },
      {
        name: 'Privacy',
        path: '/privacy',
        component: () => import('../views/Privacy.vue'),
      }
    ]
  },
  {
    name: "Master",
    path: "/master",
    component: () => import('../views/layout/Master.vue'),
    redirect: '/dashboard',
    children: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Projects',
        path: '/projects',
        component: () => import('../views/Projects.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'DataOrganizations',
        path: '/dataorganizations',
        component: () => import('../views/DataOrganization.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Associations',
        path: '/associations',
        component: () => import('../views/Associations.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Runs',
        path: '/runs',
        component: () => import('../views/Runs.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Artifacts',
        path: '/artifacts',
        component: () => import('../views/Items/Artifact.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Shares',
        path: '/shares',
        component: () => import('../views/Share.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'SharePlace',
        path: '/shareplace',
        component: () => import('../views/SharePlace.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'SharePlaceDetails',
        path: '/shareplacedetails',
        component: () => import('../views/Items/SharePlaceDetails.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'AboutMe',
        path: '/aboutme',
        component: About,
      },
      {
        name: 'Association',
        path: '/association',
        component: () => import('../views/Items/Association.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/association/:id',
        name: 'AssociationEdit',
        meta: { requiresAuth: true },
        component: () => import('../views/Items/Association.vue')
      },
      {
        name: 'Entity',
        path: '/entity',
        component: () => import('../views/Items/Entity.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'RefEntity',
        path: '/refentity',
        component: () => import('../views/Items/RefEntity.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Runs',
        path: '/runs',
        component: () => import('../views/Runs.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'ShareTemplate',
        path: '/sharetemplate/:id',
        component: () => import('../views/Items/ShareTemplate.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'ModerateShares',
        path: '/moderate-shares',
        component: () => import('../views/ModerateShares.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'ModerateSharesDetails',
        path: '/moderatesharesdetails',
        component: () => import('../views/Items/ModerateSharesDetails.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'TemplateViewInfo',
        path: '/templateviewinfo',
        component: () => import('../views/Items/TemplateViewInfo.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Entitys',
        path: '/entitys',
        component: () => import('../views/Items/Entity.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'RefEntitys',
        path: '/refentitys',
        component: () => import('../views/Items/RefEntity.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Templates',
        path: '/templates',
        component: () => import('../views/Items/TemplatesList.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Template',
        path: '/template',
        component: () => import('../views/Items/DocumentTemplate.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/template/:id',
        name: 'TemplateEdit',
        meta: { requiresAuth: true },
        component: () => import('../views/Items/DocumentTemplate.vue')
      },
      {
        path: '/relational',
        name: 'Relational',
        meta: { requiresAuth: true },
        component: () => import('../views/Items/RelationalEditing.vue')
      },
      {
        path: '/relational/:id',
        name: 'RelationalEdit',
        meta: { requiresAuth: true },
        component: () => import('../views/Items/RelationalEditing.vue')
      },
      {
        name: 'CustomLists',
        path: '/customlists',
        component: () => import('../views/CustomLists.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Trackings',
        path: '/trackings',
        component: () => import('../views/Trackings.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company',
        path: '/company',
        component: () => import('../views/Company.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'CompanyUsers',
        path: '/company-users',
        component: () => import('../views/CompanyUsers.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Perfil',
        path: '/perfil',
        component: () => import('../views/Perfil.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'NeedToChangePassword',
        path: '/need-to-change-password',
        component: () => import('../views/NeedToChangePassword.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Notifications',
        path: '/notifications',
        component: () => import('../views/Notifications.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Prompt',
        path: '/prompt',
        component: () => import('../views/Prompt.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Configuration',
        path: '/configuration',
        component: () => import('../views/Configuration.vue'),
        meta: { requiresAuth: true },
      }      
    ]
  },
  {
    name: 'ConfirmEmail',
    path: '/confirmemail',
    component: () => import('../views/ConfirmEmail.vue'),
  },
  {
    name: 'SocialLoginCallback',
    path: '/auth/callback/:provider',
    component: () => import('../views/SocialLoginCallback.vue'),
  },
  {
    name: 'CheckoutSuccess',
    path: '/checkout/success',
    component: () => import('../views/CheckoutSuccess.vue'),
    meta: { requiresAuth: true },
  },
  {
    name: 'CheckoutCancel',
    path: '/checkout/cancel',
    component: () => import('../views/CheckoutCancel.vue'),
    meta: { requiresAuth: true },
  },
  {
    name: 'WaitingPayment',
    path: '/waiting-payment',
    component: () => import('../views/WaitingPayment.vue'),
    meta: { requiresAuth: true },
  },
  {
    name: 'WaitingRecovery',
    path: '/waiting-recovery',
    component: () => import('../views/WaitingRecovery.vue'),
  },
  {
    // Target of the recovery e-mail link (backend LoginRecoveryLink: /recovery?code=<recoveryKey>)
    name: 'ResetPassword',
    path: '/recovery',
    component: () => import('../views/ResetPassword.vue'),
  },
  {
    // Target of the user data deletion e-mail link (backend UserDataDeletionLink: /confirmuserdatadeletion?code=<token>)
    name: 'ConfirmUserDataDeletion',
    path: '/confirmuserdatadeletion',
    component: () => import('../views/ConfirmUserDataDeletion.vue'),
  },
  {
    name: 'CompleteRegistration',
    path: '/completeregistration',
    component: () => import('../views/CompleteRegistration.vue'),
    meta: { requiresAuth: true },
  },
  {
    name: 'Validate2FA',
    path: '/validate2fa',
    component: () => import('../views/Validate2FA.vue'),
    meta: { requiresAuth: true },
  },
  {
    name: 'TemplateViewPopUp',
    path: '/templateviewpopup',
    component: () => import('../views/Items/TemplateViewInfo.vue'),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from) => {

  console.log('Navigation Attempt:', { to: to.fullPath, from: from.fullPath });
  
  if (to.name === 'Sign-In' || to.name === 'Sign-Up' || to.name === 'Register' || to.name === 'Home' || to.name === 'About' || to.name === 'Contact' || to.name === 'Services' || to.name === 'Pricing' || to.name === 'ResetPassword') {
    // Choice saved in this browser (ActionBar), otherwise the system theme and the browser language
    isDark.value = resolveIsDark();
    i18n.global.locale = resolveLocale();
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const authStore = useAuthStore();
    console.log('Check Auth From:', from, authStore.isAuthenticated);
    await authStore.userinfo();

    isDark.value = authStore.theme == 'dark' ? true : false;
    i18n.global.locale = (authStore.preferredLanguage?.toLowerCase() == 'pt-br' ? 'pt' : 'en');

    if (!authStore.isAuthenticated && to.matched.some(record => record.meta.requiresAuth)) {
      console.log('Check NotAuth matched path', authStore.isAuthenticated);
      if (!authStore.isAuthenticated) {
        console.log('Check NotAuth Redirect', authStore.isAuthenticated);
        return { name: 'Home' }
      }
      console.log('Check NotAuth Not Redirect', authStore.isAuthenticated);
    }

    if (authStore.isAuthenticated) {
      console.log('User Redirect', authStore.redirect);
      
      if(authStore.redirect)
        {
           console.log('undefined call User Redirect', authStore.redirect);
          if(to.name != authStore.redirect){
            return { name: authStore.redirect }
          }
        }

      if (to.name === 'Home') {
        console.log('Auth Redirect to Dashboard', authStore.isAuthenticated);
        return { name: 'Dashboard' }
      }
    }
  }
});

export default router;
